export default __webpack_public_path__ + "static/media/img_4.1f080d26.jpeg";